import React from 'react';
const tomes = [{
  label: '0-6m',
  color: 'rgb(21, 101, 192)',
  emoji: '🍼',
  desc: 'Reflejos y vínculo'
}, {
  label: '6-12m',
  color: 'rgb(46, 125, 50)',
  emoji: '🧸',
  desc: 'Exploración sensorial'
}, {
  label: '12-18m',
  color: 'rgb(230, 81, 0)',
  emoji: '🚶',
  desc: 'Primeros pasos'
}, {
  label: '18-24m',
  color: 'rgb(106, 27, 154)',
  emoji: '🗣️',
  desc: 'Lenguaje y juego'
}, {
  label: '24-30m',
  color: 'rgb(55, 71, 79)',
  emoji: '✏️',
  desc: 'Motricidad fina'
}, {
  label: '30-36m',
  color: 'rgb(191, 54, 12)',
  emoji: '🧩',
  desc: 'Autonomía y social'
}];
const features = ['✅ Criterio profesional en cada sesión', '✅ 144 sesiones completas con objetivo y cierre', '✅ Fichas imprimibles + Checklists de seguimiento', '✅ Guiones para familias + Protocolos de alerta'];
export function ProductShowcase() {
  return <section className="w-full bg-white px-4 py-10 text-gray-900 text-base leading-6" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-250">
      <div className="mx-auto max-w-4xl text-center" data-id="element-251">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-cyan-brand border border-cyan-brand/50 bg-cyan-brand/5 rounded-full px-4 py-1.5" data-id="element-252">
          🏆 El sistema más completo de Estimulación Temprana
        </div>

        {/* Title */}
        <h2 className="text-4xl leading-[40px] font-black text-gray-900 m-0 mb-2" data-id="element-253">
          👶 CONSTRUYE PROGRESO™
        </h2>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-cyan-brand m-0 mb-4" data-id="element-254">
          MEGAPACK ESTIMULACIÓN TEMPRANA
        </h3>

        {/* Description */}
        <p className="mx-auto max-w-2xl text-base leading-[24px] text-gray-800 m-0 mb-8" data-id="element-255">
          <strong data-id="element-256">6 Tomos + 6 Bonos — 0 a 36 meses — Todo resuelto.</strong>
          <br data-id="element-257" />
          +380 páginas · 144 sesiones modelo · 24 fichas imprimibles ·
          Neurodesarrollo · Semáforo de alertas · Planificación · Seguimiento ·
          Guiones para familias · Protocolos de derivación. Funciona desde hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-8" data-id="element-258">
          <div className="grid grid-cols-6 justify-center gap-2" data-id="element-259">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center justify-between aspect-[3/4] shadow-md border-2 border-cyan-brand rounded-lg overflow-hidden" style={{
            backgroundColor: tome.color
          }} data-id="element-260">
                <div className="flex-1 flex items-center justify-center" data-id="element-261">
                  <span className="text-3xl sm:text-4xl drop-shadow-lg" data-id="element-262">
                    {tome.emoji}
                  </span>
                </div>
                <div className="w-full bg-black/30 backdrop-blur-sm py-1.5 px-1 text-center" data-id="element-263">
                  <span className="block text-[10px] font-bold text-white" style={{
                textShadow: 'rgba(0, 0, 0, 0.8) 0px 1px 3px'
              }} data-id="element-264">
                    {tome.label}
                  </span>
                  <span className="block text-[8px] sm:text-[9px] text-white/80 leading-tight mt-0.5" data-id="element-265">
                    {tome.desc}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge overlay */}
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap bg-cyan-brand text-[10px] font-black text-white rounded-full px-3 py-1 shadow-sm" data-id="element-266">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Feature Tags */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-267">
          {features.map(feature => <span key={feature} className="bg-cyan-brand/5 text-xs font-semibold text-cyan-brand border border-cyan-brand/30 rounded-full px-3 py-1.5" data-id="element-268">
              {feature}
            </span>)}
        </div>
      </div>
    </section>;
}